import { Component, OnInit } from '@angular/core';
import { PermissionCheckerService } from '@shared/auth/permission-checker.service';
import { AppSessionService } from '@shared/session/app-session.service';
import { HelpDeskService } from '@shared/help-desk/help-desk.service';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppConsts } from '@shared/AppConsts';

@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})
export class HomePage implements OnInit {
  AppConsts: AppConsts = AppConsts;
  constructor(
    private permissionChecker: PermissionCheckerService,
    private sessionService: AppSessionService,
    private helpDeskService: HelpDeskService,
    private titleService: Title,
    private router: Router
  ) { 
    this.titleService.setTitle('OACI - Home');
  }

  ngOnInit() {
  }
  isUserLoggedIn(): boolean {
    return this.sessionService.user != null;
  }
  shouldShowInfobar(): boolean {
    return this.sessionService.user && !this.permissionChecker.isGranted("Pages.Certifications") && this.permissionChecker.isGranted("Pages.Farmer");
  }
  openHelpDeskPopup() {
    this.helpDeskService.openHelpDeskPopup();
  }
  goToLogin() {
    this.router.navigate(["/account/login"]);
  }
  goToRegister() {
    this.router.navigate(["/account/register"]);
  }
}
